export const PAYMENT_PLAN_RULES = [
  { payments: 1, discount: 10, surcharge: 0 },
  { payments: 2, discount: 5, surcharge: 0 },
  ...Array.from({ length: 8 }, (_, index) => ({ payments: index + 3, discount: 0, surcharge: index + 3 })),
];

export const clampPaymentOptionCount = (value) => Math.max(1, Math.min(10, Number(value) || 2));

export const calculatePaymentOptions = (fees, count = 2) => {
  const base = Math.max(0, Number(fees) || 0);
  return PAYMENT_PLAN_RULES.slice(0, clampPaymentOptionCount(count)).map((rule) => {
    const adjustmentPercent = rule.surcharge - rule.discount;
    const total = Math.round((base * (1 + adjustmentPercent / 100) + Number.EPSILON) * 100) / 100;
    return {
      ...rule,
      total,
      installment: Math.round((total / rule.payments + Number.EPSILON) * 100) / 100,
    };
  });
};

export const formatPaymentMoney = (value) => Number(value || 0).toLocaleString('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});
